import { jsx as _jsx } from "react/jsx-runtime";
export default (({
  ...extra
}) => /*#__PURE__*/_jsx("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  ...extra,
  children: /*#__PURE__*/_jsx("path", {
    d: "M5.80703 14.0017C5.41173 14.0017 5.04467 13.8448 4.77173 13.5586L0.376438 8.94258C-0.150621 8.37943 -0.122386 7.51163 0.44232 6.9854C1.01644 6.45918 1.90114 6.49611 2.43761 7.05003L5.79761 10.5859L13.5529 2.44327C14.0894 1.88012 14.9741 1.85242 15.5482 2.37865C16.1223 2.90487 16.1506 3.77267 15.6141 4.33583L6.83291 13.5586C6.56938 13.8355 6.19291 14.0017 5.79761 14.0017H5.80703Z",
    fill: "#1CC78E"
  })
}));